import { api } from "@/lib/api";

export const downloadSheetPdf = async (span, date) => {
  const res = await api.get("/export/schedule.pdf", {
    params: { span, date },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${span}-sheet-${date}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const downloadWeekPack = async (start) => {
  const res = await api.get("/kit/week.pdf", { params: { start }, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `travel-pack-${start}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const downloadDueBoardPdf = async (start) => {
  const res = await api.get("/due-board/pdf", { params: { start }, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `due-board-${start}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const openPrintSheet = (span, date) => {
  window.open(`/print?span=${span}&date=${date}`, "_blank", "noopener");
};

export const downloadAssociateBriefPdf = async (date) => {
  const res = await api.get("/brief/associate.pdf", {
    params: { date },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `associate-brief-${date}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
